import React from 'react'
import styles from './Footer.module.css';
import { pageLinks} from '../data'
import { FaGithub } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { PiMediumLogoFill } from "react-icons/pi";
import { FaInstagram } from "react-icons/fa";

// sosyal iconlar ve tıklandığında yeni sayfada açılmasını sağlar
const handleRedirectToGithub = () => {
  window.open('https://github.com/mrTuranWebDeveloper', '_blank');
};

const handleRedirectToLinkedin = () => {
  window.open('https://www.linkedin.com/in/%C3%B6mer-turan-381301282/', '_blank');
};

const handleRedirectToMedium = () => {
  window.open('https://medium.com/@omerturan00720', '_blank');
};

const handleRedirectToInstagram = () => {
  window.open('https://www.instagram.com/mrtrn_20_/', '_blank');
};



const Footer = () => {
  return (
    
    <footer className={styles.footerSection}>
    <ul className={styles.footerLinks}>
      {pageLinks.map((link)=>{
        const {id, href, text} = link
        return (
          <li key={id}>
          <a href={href} className={styles.footerLink}>{text}</a>
          </li>
        )
      })}
     
     </ul>

    <ul className={styles.footerIcons}>

         <li><FaGithub onClick={handleRedirectToGithub} className={styles.footerIcon} /></li>
         <li><FaLinkedin onClick={handleRedirectToLinkedin} className={styles.footerIcon}  /></li>
         <li><PiMediumLogoFill onClick={handleRedirectToMedium} className={styles.footerIcon} /></li>
         <li><FaInstagram onClick={handleRedirectToInstagram} className={styles.footerIcon} /></li>
  
    </ul>

  

    <p className={styles.copyright}>
      copyright &copy; Turan SoftWare Company
      <span id="date">{new Date().getFullYear()}</span> all rights reserved
    </p>
    </footer>
    
  )
}

export default Footer